<template>
  <el-dialog
      title="Xuất Excel nhập học, nghỉ học"
      :visible.sync="dialogVisible"
      width="540px"
      :before-close="closeDialog"
      :close-on-click-modal="false"
      custom-class="sk-dialog"
  >
    <div class="sk-dialog-content">
      <div class="sk-panel">
        <div class="sk-panel-head">
          <div class="sk-panel-icon" style="background: linear-gradient(135deg, #a78bfa, #7c3aed)">
            <i class="el-icon-download"></i>
          </div>
          <div>
            <p class="sk-panel-title">Xuất Excel nhập học / nghỉ học</p>
            <p class="sk-panel-subtitle">Chọn trạng thái và khoảng thời gian để xuất file Excel.</p>
          </div>
        </div>
        <el-form label-width="200px" label-position="left">
          <el-form-item label="Trạng thái">
            <el-radio-group v-model="radio">
              <el-radio :label="status.STUDY_WAIT">Nhập học</el-radio>
              <el-radio :label="status.LEAVE_SCHOOL">Nghỉ học</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="Chọn khoảng thời gian">
            <el-date-picker
                style="width: 100%"
                value-format="yyyy-MM-dd"
                format="dd-MM-yyyy"
                v-model="valueDate"
                type="daterange"
                unlink-panels
                range-separator="-"
                start-placeholder="Ngày bắt đầu"
                end-placeholder="Ngày kết thúc"
                :picker-options="pickerOptions"
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <span slot="footer" class="dialog-footer sk-dialog-footer">
      <el-button class="btn-cancel" type="danger" size="medium" @click="closeDialog()">
        <i class="el-icon-circle-close"/>
        <span>{{ $t("button.close") }}</span>
      </el-button>
      <el-button
          class="btn-save"
          type="success"
          size="medium"
          :loading="loadingButton"
          mini
          @click="submitForm()"
      >
        <i class="el-icon-circle-check"/>
        <span>Xuất Excel</span>
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import moment from "moment/moment";
import StudentService from "@/services/StudentService";

export default {
  props: {
    dialogVisible: null,
    idGrade: null,
    idClass: null
  },
  data() {
    return {
      pickerOptions: this.$funcCommon.quickOptionDate(),
      valueDate: [],
      radio: 'STUDY_WAIT',
      status: {
        STUDY_WAIT: 'STUDY_WAIT',
        LEAVE_SCHOOL: 'LEAVE_SCHOOL',
      },
      styleCols1: [],
      styleCols2: [],
      loadingButton: false,
    };
  },
  methods: {
    //reset when click x
    closeDialog() {
      this.$emit("dialog-close");
      setTimeout(() => {
        this.loadingButton = false;
      }, 300);
    },
    getStyleExcelStudent() {
      let font = this.$styleExcel.fontTitle();
      let alignment = this.$styleExcel.alignmentTitle();
      let border = this.$styleExcel.borderTitle();
      let styleCol1 = {
        name: "A5:P5",
        style: {
          fill: {fgColor: {rgb: "ffff00"}},
          font,
          alignment,
          border,
        },
      };
      let styleCol2 = {
        name: "Q5:U5",
        style: {
          fill: {fgColor: {rgb: "ffb2bd"}},
          font,
          alignment,
          border,
        },
      };
      let styleCol3 = {
        name: "V5:AB5",
        style: {
          fill: {fgColor: {rgb: "78f388"}},
          font,
          alignment,
          border,
        },
      };
      //style1
      let styleCol4 = {
        name: ["A1"],
        style: {
          font: {color: {rgb: "ff0000"}, bold: true, sz: "18"},
        },
      };
      let styleCol5 = {
        name: ["A2", "A3", "A4"],
        style: {
          font: {bold: true, sz: "11"},
        },
      };
      this.styleCols2.push(styleCol1);
      this.styleCols2.push(styleCol2);
      this.styleCols2.push(styleCol3);

      this.styleCols1.push(styleCol4);
      this.styleCols1.push(styleCol5);
    },
    exportExcel() {
      this.getStyleExcelStudent();
      let myDate = moment(new Date()).format("DD-MM-YYYY hh:mm:ss");
      let fileNameExport = (this.radio == this.status.STUDY_WAIT) ? "NHAP_HOC" : "NGHI_HOC";
      StudentService.exportExcelStudentAdmissionOrLeaveNew(this.idGrade, this.idClass, this.radio, this.valueDate)
          .then((resp) => {
            import("@/services/ExportExcel")
                .then((excel) => {
                  let dataList = resp.data.data;
                  let fileName = `QUAN_LY_HOC_SINH_${fileNameExport}_${myDate}`;
                  const tHeader = [
                    "STT",
                    "Tình trạng",
                    "Khối học",
                    "Lớp học",
                    "Tên nhóm",
                    "Họ và tên",
                    "Ngày sinh",
                    "Giới tính",
                    "Biệt danh",
                    "Địa chỉ hiện tại",
                    "Địa chỉ thường trú",
                    "Dân tộc",
                    "Số định danh",
                    "Người đại diện",
                    "Ngày nhập học",
                    "Ngày bảo lưu",
                    "Ngày nghỉ",
                    "Họ tên mẹ",
                    "Ngày sinh",
                    "Số điện thoại",
                    "Email",
                    "Nghề nghiệp",
                    "Họ tên bố",
                    "Ngày sinh",
                    "Số điện thoại",
                    "Email",
                    "Nghề nghiệp",
                    "Ghi chú",
                  ];
                  const filterVal = [
                    "pro1",
                    "pro2",
                    "pro3",
                    "pro4",
                    "pro5",
                    "pro6",
                    "pro7",
                    "pro8",
                    "pro9",
                    "pro10",
                    "pro11",
                    "pro12",
                    "pro13",
                    "pro14",
                    "pro15",
                    "pro16",
                    "pro17",
                    "pro18",
                    "pro19",
                    "pro20",
                    "pro21",
                    "pro22",
                    "pro23",
                    "pro24",
                    "pro25",
                    "pro26",
                    "pro27",
                    "pro28",
                  ];
                  let columnList = [
                    {col: 5},
                    {col: 15},
                    {col: 15},
                    {col: 15},
                    {col: 15},
                    {col: 25},
                    {col: 15},
                    {col: 10},
                    {col: 20},
                    {col: 25},
                    {col: 25},
                    {col: 10},
                    {col: 15},
                    {col: 15},
                    {col: 15},
                    {col: 15},
                    {col: 15},
                    {col: 25},
                    {col: 15},
                    {col: 15},
                    {col: 25},
                    {col: 15},
                    {col: 25},
                    {col: 15},
                    {col: 15},
                    {col: 25},
                    {col: 15},
                    {col: 30},
                  ];
                  excel.export_json_to_excel({
                    header: tHeader,
                    data: dataList,
                    title: filterVal,
                    filename: fileName,
                    columnsWidth: columnList,
                    styleCols1: this.styleCols1,
                    styleCols2: this.styleCols2,
                  });
                })
                .finally(() => {
                  this.styleCols1 = [];
                  this.styleCols2 = [];
                });
          })
          .catch((err) => {
            console.log(err);
            this.$message({
              message: "Thất bại",
              type: "error",
            });
          });
    },
    submitForm() {
      if(this.valueDate.length <2){
        this.$message({
          message:"Vui lòng chọn khoảng thời gian",
          type:"warning"
        });
        return;
      }
      this.loadingButton = true;
      this.exportExcel();
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      setTimeout(() => {
      this.loadingButton = false;
        loading.close();
      }, 2000);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/sk-dialog.scss";
</style>
